<div class="flex flex-col gap-6 p-6">
  <div class="flex items-center justify-between">
    <h1 class="textTabsColor text-2xl font-bold" i18n="@@returnRequestsListTitle">المرتجعات</h1>
  </div>

  <app-return-requests-filter
    [initialFilters]="filters()"
    [statusOptions]="statusOptions()"
    (applyFilters)="onApplyFilters($event)"
    (resetFilters)="onResetFilters()" />

  @if (state() === "loading") {
    <div
      class="flex min-h-[300px] w-full items-center justify-center rounded-2xl border border-gray-100 bg-white p-12 shadow-sm">
      <app-loading />
    </div>
  } @else {
    <app-tables
      [headerItems]="tableHeaderData()"
      [rows]="rows()"
      [currentActions]="currentActions()"
      [isFiltersApplied]="isFiltersApplied()"
      [emptyFilterTitle]="
        isArabic()
          ? 'لا توجد طلبات مرتجعات مطابقة لمعايير البحث المحددة.'
          : 'No return requests match the search criteria.'
      "
      [emptyContentTitle]="isArabic() ? 'لا توجد طلبات مرتجعات' : 'No return requests found'"
      [emptyContentDescription]="
        isArabic() ? 'لم يتم العثور على أي طلبات مرتجعات حالياً.' : 'No return requests are currently available.'
      "
      (toggleDropdown)="onToggleDropdown($event)"
      (actionTrigger)="onActionTrigger($event)" />
  }

  <app-pagination
    [itemsPerPage]="itemsPerPage()"
    [currentPage]="currentPage()"
    [getPageNumbers]="getPageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="onPreviousPage()"
    (nextPage)="onNextPage()"
    (goToPage)="onGoToPage($event)"
    (changePageNumber)="onGoToPage($event)"
    (pageSizeChange)="onPageSizeChange()" />
</div>
